<template>
    <img v-if="loadedAsset" :src="loadedAsset.url" :alt="loadedAsset.title" />
    <div v-else-if="loadedAsset === false" class="image-not-found"></div>
    <svg
        v-else
        class="loader"
        width="38"
        height="38"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#131313"
    >
        <g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd">
            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
            <path d="M36 18c0-9.94-8.06-18-18-18">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 18 18"
                    to="360 18 18"
                    dur="1s"
                    repeatCount="indefinite"
                />
            </path>
        </g>
    </svg>
</template>

<script>
import { isNil } from 'lodash'

import { getAssetById } from '@/plugins/Helpers'

export default {
    name: 'AssetLoader',

    props: {
        asset: {
            type: Object,
            required: true,
        },
        transform: {
            type: String,
            default: '',
            required: false,
        },
    },

    data() {
        return {
            loadedAsset: null,
        }
    },

    watch: {
        asset: {
            async handler(asset) {
                if (!isNil(asset) && asset.asset) {
                    try {
                        const res = await getAssetById(asset.asset, this.transform)
                        this.loadedAsset = res
                    } catch (error) {
                        // console.log(error)
                        this.loadedAsset = false
                    }
                }
            },
            immediate: true,
        },
    },
}
</script>

<!-- EXAMPLE -->
<!-- <AssetLoader v-else :asset="{ asset: 748 }" transform="?mode=crop&width=10&height=5" /> -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
